<!-- @migration-task Error while migrating Svelte code: $$props is used together with named props in a way that cannot be automatically migrated. -->
<script lang="ts">
    import { onDestroy, onMount } from "svelte";
    import { Booking, BOOKING_STATUS } from "../../model/Booking";
    import BootstrapVectorIcon from "../components/BootstrapVectorIcon.svelte";
    import { Slot } from "../../model/Slot";
    import type {
        IBookingController,
        IStatsController,
    } from "../../controller";
    import { ConfigurationManager } from "../../ConfigurationManager";
    import jQuery from "jquery";
    import PromisedComponentHandler from "../components/PromisedComponentHandler.svelte";
    import {
        DefaultErrorHandler,
        getMessagingService,
        MESSAGE_TYPE,
        type MessagingService,
    } from "../../utility/ContextHelper.svelte";
    import BookingStatusBadge from "../components/BookingStatusBadge.svelte";

    export let booking: Booking;
    export let bookingSlot: Slot = null;
    export let includeSummaryStats: boolean = false;

    /**
     * The current total earnings for this booking
     */
    let currentTotalEarnings: number = 0;

    let totalEarningsRefreshTimeout = undefined;

    let msgSrvc: MessagingService = getMessagingService();

    let statsController: IStatsController =
        ConfigurationManager.getInstance().statsController;
    function updateEarnings() {
        statsController
            .getTotalEarningForBooking(booking.id)
            .then((totalTurnover: number) => {
                jQuery(".totalEarnings")
                    .fadeOut(500, "linear", () => {
                        currentTotalEarnings = totalTurnover;
                        jQuery(".totalEarnings").fadeIn(500);
                    });
                    
            }).finally(() => {
                totalEarningsRefreshTimeout = setTimeout(updateEarnings, 5000);
            });

    }

    let bookingController: IBookingController =
        ConfigurationManager.getInstance().bookingController;
    function endBooking() {
        bookingController
            .endBooking(booking.id)
            .then(() => {
                booking.status = BOOKING_STATUS.aborted;
                booking = booking;
                msgSrvc.BoradcastMessage(
                    "Booking has been ended",
                    MESSAGE_TYPE.SUCCESS,
                );
            })
            .catch(DefaultErrorHandler);
    }


    function pauseBooking() {
        bookingController
            .pauseBooking(booking.id)
            .then(() => {
                booking.status = BOOKING_STATUS.paused;
                booking = booking;
                msgSrvc.BoradcastMessage(
                    "Booking has been paused",
                    MESSAGE_TYPE.SUCCESS,
                );
            })
            .catch(DefaultErrorHandler);
    }

    function restartBooking() {
        bookingController
            .restartBooking(booking.id)
            .then(() => {
                booking.status = BOOKING_STATUS.live;
                booking = booking;
                msgSrvc.BoradcastMessage(
                    "Booking has been restarted",
                    MESSAGE_TYPE.SUCCESS,
                );
            })
            .catch(DefaultErrorHandler);
    }

    onMount(() => {
        booking.slot.then((slot: Slot) => {
            bookingSlot = slot;
        });

        updateEarnings();
    });

    onDestroy(() => {
        if (totalEarningsRefreshTimeout) {
            clearTimeout(totalEarningsRefreshTimeout);
        }
    });
</script>

<div class=" {$$props.class}" style={$$props.style || ""}>
    <div class="h-100 mb-0 card ">
        <div class="card-header ">
            <!-- Title -->
            <h2 class="card-header-title h4 text-uppercase mb-3">Booking</h2>
            {booking.name}
        </div>

        <div class="card-body pt-0">
            <h3 class="h6 small text-info text-uppercase mb-3">About</h3>

            <ul class="list-unstyled mb-7">
                <li class="py-2">
                    <BootstrapVectorIcon
                        icon="calendar-event"
                        style="height: 1em; width: 1em;"
                    ></BootstrapVectorIcon>
                    {booking.start ? booking.start.toLocaleString() : "-"}
                </li>
                <li class="py-2">
                    <BootstrapVectorIcon
                        icon="badge-tm"
                        style="height: 1em; width: 1em;"
                    ></BootstrapVectorIcon>
                    {booking.brand}
                </li>
                <li class="py-2">
                    <BootstrapVectorIcon
                        icon="building"
                        style="height: 1em; width: 1em;"
                    ></BootstrapVectorIcon>
                    {booking.advertiser}
                </li>
                <li class="py-2">
                    <BootstrapVectorIcon
                        icon="controller"
                        style="height: 1em; width: 1em;"
                    ></BootstrapVectorIcon>
                    {#if bookingSlot}
                        <a href="#/game/{bookingSlot.gameId}">
                            <PromisedComponentHandler
                                retrievalPromise={bookingSlot.game}
                            >
                                {#snippet children(game)}
                                    {game.name}
                                {/snippet}
                            </PromisedComponentHandler>
                        </a>
                    {/if}
                </li>
            </ul>

            <h3 class="h6 small text-info text-uppercase mb-3">Status</h3>

            <h3>
                <BookingStatusBadge status={booking.status}
                ></BookingStatusBadge>
                {#if booking.status == BOOKING_STATUS.paused}
                    <div style="display: inline;" on:click={restartBooking}>
                        <BootstrapVectorIcon
                        style="height: 1em; width: 1em; cursor: pointer;"
                        icon="play-fill"
                        class="text-success"
                        ></BootstrapVectorIcon>
                    </div>

                {/if}
                {#if booking.status == BOOKING_STATUS.live}
                    <div style="display: inline;" on:click={pauseBooking}>
                        <BootstrapVectorIcon
                        style="height: 1em; width: 1em; cursor: pointer;"
                        icon="pause-fill"
                        class="text-info"
                        ></BootstrapVectorIcon>
                    </div>&nbsp;
                    <div style="display: inline;" on:click={endBooking}>
                        <BootstrapVectorIcon
                        style="height: 1em; width: 1em; cursor: pointer;"
                        icon="stop-fill"
                        class="text-danger"
                        ></BootstrapVectorIcon>
                    </div>
                {/if}

            </h3>
            <ul class="list-unstyled mb-7">
                <li class="py-2">
                    <div
                        class="d-flex justify-content-between align-items-center"
                    >
                        <div class="progress w-100 h-10px">
                            <div
                                class="progress-bar bg-success"
                                role="progressbar"
                                style="width: {Math.round(
                                    (currentTotalEarnings /
                                        booking.volumeTotal) *
                                        100,
                                )}%"
                                aria-valuenow={Math.round(
                                    (currentTotalEarnings /
                                        booking.volumeTotal) *
                                        100,
                                )}
                                aria-valuemin="0"
                                aria-valuemax="100"
                            ></div>
                        </div>
                        <span class="ms-3 text-body-secondary"
                            >{Math.round(
                                (currentTotalEarnings / booking.volumeTotal) *
                                    100,
                            )}%</span
                        >
                    </div>
                </li>
                <li class="py-2">
                    <BootstrapVectorIcon
                        icon="cash-stack"
                        style="height: 1em; width: 1em;"
                    ></BootstrapVectorIcon>
                    <span class="totalEarnings"
                        >{currentTotalEarnings
                            ? currentTotalEarnings.toLocaleString()
                            : 0}</span
                    >
                    € of {booking.volumeTotal.toLocaleString()}
                    €
                </li>
            </ul>

        </div>
    </div>
</div>
